// Home page English translations

export default {
  // Hero Section
  scrollDown: "Scroll Down",
  playFullMovie: "Play full movie",
  
  // Get Started Section
  innovationTitle: "Innovation and Excellence in Precision Manufacturing.",
  innovationDesc1: "P.T. Eagle Industry Indonesia is part of Eagle Industry Co., Ltd., Japan, which has been operating for decades in providing high-quality components for various industries. We prioritize advanced technology, product reliability, and customer satisfaction to support global market needs.",
  innovationDesc2: "With modern production facilities in Indonesia, we ensure international quality standards and timely delivery to meet the needs of our customers across various sectors.",
  
  // Products Section
  productsTitle: "PRODUCTS",
  productsDesc: "We provide mechanical seals and various mechanical products for land, sea and air mobility, plant equipment and semiconductor manufacturing equipment.",
  learnMore: "Learn More",
  searchByCategory: "Search by \ncategory",
  searchByIndustry: "Search by \nIndustry",
  searchByKeyword: "Search by \nkeyword",
  enterKeywords: "Enter product keywords",
  
  // Categories
  mechanicalSeals: "Mechanical Seals",
  lipSeal: "Lip Seal",
  valves: "Valves",
  floatingSeal: "Floating Seal",
  accumulators: "Accumulators",
  waterLubricatedSternTubeSeal: "Water Lubricated Stern Tube Seal",
  waterLubricatedSternTubeBearing: "Water Lubricated Stern Tube Bearing",
  serviceEngineer: "Service Engineer",
  
  // Industries
  oilGas: "Oil, Gas & General Industry",
  automobile: "Automobile & Motorcycle",
  constructionAgriculture: "Construction & Agriculture",
  marine: "Marine",
  
  // Services Section
  ourServices: "Our Services",
  servicesDesc: "We provide comprehensive solutions for your precision component needs.",
  customManufacturing: "Custom Manufacturing",
  customManufacturingDesc: "We offer custom manufacturing solutions to meet specific customer needs across various industries.",
  technicalSupport: "Technical Support",
  technicalSupportDesc: "Our expert team provides technical support to ensure optimal performance of our products.",
  afterSalesService: "After-Sales Service",
  afterSalesServiceDesc: "We provide reliable after-sales service to ensure customer satisfaction.",
  qualityAssurance: "Quality Assurance",
  qualityAssuranceDesc: "Our rigorous quality control processes ensure that all products meet international standards and customer specifications.",
  researchDevelopment: "Research & Development",
  researchDevelopmentDesc: "Our R&D team continuously innovates to develop advanced sealing solutions that address evolving industry challenges.",
  globalSupplyChain: "Global Supply Chain",
  globalSupplyChainDesc: "We maintain an efficient global supply network to ensure timely delivery of products to customers worldwide.",
  readMore: "Read more",
  
  // Features Section
  floatingSeal: "Floating Seal",
  mechanicalSealFeature: "Mechanical Seal",
  lipSealFeature: "Lip Seal",
  rudder: "Rudder",
  
  floatingSealDesc: "Precision floating seals for heavy-duty applications in harsh environments.",
  floatingSealFeature1: "Excellent resistance to wear and extreme operating conditions",
  floatingSealFeature2: "Self-lubricating design for enhanced performance and longevity",
  floatingSealFeature3: "Ideal for construction, mining, and agricultural equipment",
  floatingSealFeature4: "Customizable configurations to meet specific application needs",
  
  mechanicalSealDesc: "High-performance mechanical seals designed for demanding industrial applications.",
  mechanicalSealFeature1: "Engineered for superior durability and extended service life",
  mechanicalSealFeature2: "Suitable for high-pressure, high-temperature environments",
  mechanicalSealFeature3: "Available in various materials to match specific application requirements",
  
  lipSealFeature1: "High-quality sealing for rotary and reciprocating applications",
  lipSealFeature2: "Available in various materials including NBR, FKM, and PTFE",
  lipSealFeature3: "Designed to prevent fluid leakage and contamination",
  lipSealDesc: "Reliable lip seals for automotive, industrial, and marine applications.",
  
  rudderDesc: "Advanced rudder seals for marine vessels ensuring optimal steering performance.",
  rudderFeature1: "Engineered for maximum durability in marine environments",
  rudderFeature2: "Superior resistance to corrosion and seawater conditions",
  rudderFeature3: "Designed to maintain vessel maneuverability and safety"
};